import type {
  RequestDataWithBody,
  TypedApiMethodPost,
  TypedApiMethodGet,
  TypedApiMethodPostWithRequiredParams,
  WithRequiredParams,
  RequestData,
} from '../types';

export function typedMethodPost<TParams, TDto, TDomain = TDto>(
  fn: (data: RequestDataWithBody<TParams>) => Promise<Response>,
  mapper?: (dto: TDto) => TDomain
): TypedApiMethodPost<TParams, TDto, TDomain> {
  return Object.assign(fn, { _mapper: mapper });
}

export function typedMethodGet<TParams, TDto, TDomain = TDto>(
  fn: (data: WithRequiredParams<RequestData<TParams>>) => Promise<Response>,
  mapper?: (dto: TDto) => TDomain
): TypedApiMethodGet<TParams, TDto, TDomain> {
  return Object.assign(fn, { _mapper: mapper });
}

export function typedMethodPostWithRequiredParams<TParams, TDto, TDomain = TDto>(
  fn: (data: WithRequiredParams<RequestDataWithBody<TParams>>) => Promise<Response>,
  mapper?: (dto: TDto) => TDomain
): TypedApiMethodPostWithRequiredParams<TParams, TDto, TDomain> {
  return Object.assign(fn, { _mapper: mapper });
}
